import Detail from "./Detail";
import List from "./List";
import Received from "./Received";
import SearchTransaction from "./SearchTransaction";

const routes = [
    {
        path: 'transactions',
        element: <List />
    },
    {
        path: 'searchTransaction',
        element: <SearchTransaction />
    },
    {
        path: 'transactions/receive',
        element: <Received />
    },
    {
        path: 'transactions/:id',
        element: <Detail />
    }
]
export default routes;